<template>
    <label class="form-label" :for="htmlFor" v-bind="$attrs" :class="[`${labelType}`, noMarginBottom ? 'mb--0' : '']">
        {{ title }}
        <span v-if="!customText && infoType" :class="[infoTypeObj[infoType].color || '']" class="text-gray-600 text--xs text--normal">
            {{ infoTypeObj[infoType].text || additionalText }}
        </span>
        <span v-else class="text--xs text-gray-200">
            <slot />
        </span>
    </label>
</template>

<script>
export default {
    name: "FormLabel",
    
    props: {
        title: {
            type: String,
            default: "",
        },
        htmlFor: {
            type: String,
            default: "",
        },
        infoType: {
            type: String,
            default: "",
            validator: value => !value || ["required", "optional", "info"].includes(value),
        },
        labelType: {
            type: String,
            default: "form",
            validator: value => !value || [
                "marketing", 
                "title", 
                "menu", 
                "md_mono", 
                "tabular", 
                "form", 
                "tertiary", 
                "sm_mono",
                "form_bold",
            ].includes(value),
        },
        customText: {
            type: Boolean,
            default: false,
        },
        additionalText: {
            type: String,
            default: "",
        },
        noMarginBottom: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            infoTypeObj: {
                "required": {
                    color: "text-error-400",
                    text: "*",
                },
                "info": {
                    color: "text-label-info",
                    text: "",
                },
                "optional": {
                    color: "text-label-info",
                    text: "(optional)",
                },
            },
        };
    },
};
</script>